var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { get } from "lodash";
import withBranding from "@irati/brand/withBranding";
import teamsService from "@irati/identity/services/teams";
import businessService from "@irati/identity/services/business";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Link from "@irati/ui/src/Link";
import Icon from "@irati/ui/src/Icon";
import redemptionsService from "@irati/deals/services/dealRedemption";
import { perkbox } from "@irati/ui/src/global/colors";
import authentication from "@irati/auth";
import OnboardingService from "@irati/onboarding/services/onboarding";
import { Panel } from "../../styled";
import { ProgressWrapper, PercentageButton, StepsProgressBar, StepsWrapper, StepsLabel, CheckWrapper, OnboardingStepsWrapper, OnboardingHeader } from "./style";
import AdminOnboardingStorage, { hideOnboardingWidgetKey } from "./../../helpers/storage";
var getPercentage = function (steps) {
    var keyArray = Object.keys(steps);
    var length = keyArray.length;
    var completeSteps = 0;
    keyArray.forEach(function (step) {
        if (get(steps, step)) {
            completeSteps += 1;
        }
    });
    return (completeSteps / length) * 100;
};
var onboardingSteps = [
    {
        name: "loggedIn",
        labelId: "home.admin.onboarding.loggedIn",
        link: "/"
    },
    {
        name: "teams",
        labelId: "home.admin.onboarding.createTeam",
        link: "/admin/teams"
    },
    {
        name: "employees",
        labelId: "home.admin.onboarding.inviteEmployees",
        link: "/admin/people"
    },
    {
        name: "redeemed",
        labelId: "home.admin.onboarding.redeemPerk",
        link: "/perks/discover"
    }
];
var getProgressHeader = function (percentage) {
    switch (percentage) {
        case 25:
            return "home.admin.onboarding.header2";
        case 50:
            return "home.admin.onboarding.header3";
        case 75:
            return "home.admin.onboarding.header4";
        case 100:
            return "home.admin.onboarding.header5";
        default:
            return "home.admin.onboarding.header1";
    }
};
var AdminOnboarding = /** @class */ (function (_super) {
    __extends(AdminOnboarding, _super);
    function AdminOnboarding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            steps: {
                loggedIn: true,
                teams: false,
                employees: false,
                redeemed: false
            },
            hideCard: true,
            completed: 0
        };
        _this.componentDidMount = function () {
            var tenantId = _this.props.tenantId;
            var promises = [_this.loadTeams(tenantId), _this.loadTotalActiveUsers(), _this.getRedemptions()];
            Promise.all(promises).then(function () {
                var steps = _this.state.steps;
                var completed = getPercentage(steps);
                _this.updateWidgetVisibility(completed);
                _this.setState({ completed: completed });
                OnboardingService.getTenantOnboarding()
                    .then(function (tenantOnboarding) {
                    if (!(tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.enabled)) {
                        _this.setState({ hideCard: false });
                    }
                })
                    .catch(function () {
                    _this.setState({ hideCard: false });
                });
            });
        };
        _this.updateWidgetVisibility = function (completed) {
            var hidePanel = AdminOnboardingStorage.getValue(hideOnboardingWidgetKey);
            if (completed === 100 && !hidePanel) {
                AdminOnboardingStorage.setValue(hideOnboardingWidgetKey, true);
            }
        };
        _this.loadTeams = function (tenantId) {
            return teamsService.list(tenantId).then(function (teams) {
                if (teams.length > 0) {
                    _this.setState({ steps: __assign(__assign({}, _this.state.steps), { teams: true }) });
                }
            });
        };
        _this.loadTotalActiveUsers = function () {
            var tenantId = _this.props.tenantId;
            return businessService.userCount(tenantId).then(function (userTotal) {
                if (userTotal > 1) {
                    _this.setState({ steps: __assign(__assign({}, _this.state.steps), { employees: true }) });
                }
            });
        };
        _this.getRedemptions = function () {
            return redemptionsService.list({ limit: 1 }).then(function (redemptions) {
                if (redemptions.length > 0) {
                    _this.setState({ steps: __assign(__assign({}, _this.state.steps), { redeemed: true }) });
                }
            });
        };
        return _this;
    }
    AdminOnboarding.prototype.render = function () {
        var _a = this.state, steps = _a.steps, completed = _a.completed, hideCard = _a.hideCard;
        var hidePanel = AdminOnboardingStorage.getValue(hideOnboardingWidgetKey) || hideCard;
        if (hidePanel)
            return null;
        var primaryColour = this.props.branding.primaryColour;
        var hasHomepageTiles = authentication.apps("platform.homepageTiles.read");
        var brandColor = hasHomepageTiles ? primaryColour : perkbox.blue;
        var header = getProgressHeader(completed);
        return (React.createElement(Panel, null,
            React.createElement(ProgressWrapper, null,
                React.createElement(OnboardingHeader, null,
                    React.createElement(FormattedMessage, { id: header }),
                    React.createElement(PercentageButton, { color: brandColor },
                        completed,
                        "%"))),
            React.createElement(StepsProgressBar, { now: completed, color: brandColor }),
            React.createElement(ProgressWrapper, null,
                React.createElement(OnboardingHeader, null,
                    React.createElement(FormattedMessage, { id: "home.admin.onboarding.subHeader" })),
                React.createElement(OnboardingStepsWrapper, null, onboardingSteps.map(function (_a, i) {
                    var name = _a.name, link = _a.link, labelId = _a.labelId;
                    return (React.createElement(StepsWrapper, { completed: get(steps, name), key: i },
                        React.createElement(CheckWrapper, null,
                            React.createElement(Icon, { icon: "tick", color: brandColor })),
                        React.createElement(Link, { href: link },
                            React.createElement(StepsLabel, null,
                                React.createElement(FormattedMessage, { id: labelId })))));
                })))));
    };
    return AdminOnboarding;
}(Component));
export default injectIntl(withBranding(AdminOnboarding));
